<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar v-if="currentAccount.mayNavigate()">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Übersicht',
            icon: 'ni ni-chart-pie-35 text-info',
            path: '/portal'
          }">
        </sidebar-item>

        <sidebar-item v-if="currentAccount.isUser()"
          :link="{
            name: 'Angebote / Anträge',
            icon: 'fas fa-car-crash text-info',
            path: '/offers'
          }">
        </sidebar-item>

        <sidebar-item v-if="currentAccount.isUser()"
          :link="{
            name: 'EvB',
            icon: 'fas fa-id-card text-info',
            path: '/evbs'
          }">
        </sidebar-item>

        <sidebar-item v-if="currentAccount.isUser()"
          :link="{
            name: 'Dokumente',
            icon: 'fas fa-file text-info',
            path: '/documents'
          }">
        </sidebar-item>

        <sidebar-item v-if="currentAccount.isUser()"
          :link="{
            name: 'Training',
            icon: 'fas fa-video text-info',
            path: '/training'
          }">
        </sidebar-item>
  
      </template>

      <template slot="links-after">
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">TLP Service</h6>

        <b-nav class="navbar-nav mb-md-3">
          <b-nav-item
               href="https://schulligen.de"
               >
              <i class="ni ni-ni ni-satisfied"></i>
              <b-nav-text class="p-0">Hilfe & Support</b-nav-text>
          </b-nav-item>
        </b-nav>
      </template>
    </side-bar>
    <div class="main-content">
      
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'



  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
      
    },
  computed: {
    ...mapGetters({ currentAccount: 'currentAccount' })
  },
  };
</script>
<style lang="scss">
</style>
